import { render, staticRenderFns } from "./TemplateCardSubjectBody.vue?vue&type=template&id=2d99c075&scoped=true&"
import script from "./TemplateCardSubjectBody.vue?vue&type=script&lang=ts&"
export * from "./TemplateCardSubjectBody.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCardSubjectBody.vue?vue&type=style&index=0&id=2d99c075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99c075",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
